import {FC} from 'react'
import InlineSVG from 'react-inlinesvg'
import {toAbsoluteUrl} from 'src/app/utils/asset-helpers.utils'

export enum GIconCollection {
  IconAdd = '/media/icons/IconAdd.svg',
  IconAddRounded = '/media/icons/IconAddRounded.svg',
  IconArrowTop = '/media/icons/IconArrowTop.svg',
  IconArrowRight = '/media/icons/IconArrowRight.svg',
  IconBack = '/media/icons/IconBack.svg',
  IconBell = '/media/icons/IconBell.svg',
  IconBriefcase = '/media/icons/IconBriefcase.svg',
  IconBurger = '/media/icons/IconBurger.svg',
  IconBuilding = '/media/icons/IconBuilding.svg',
  IconCalendar = '/media/icons/IconCalendar.svg',
  IconCheck = '/media/icons/IconCheck.svg',
  IconCheckCircle = '/media/icons/IconCheckCircle.svg',
  IconChevronUp = '/media/icons/IconChevronUp.svg',
  IconCrossCircle = '/media/icons/IconCrossCircle.svg',
  IconClock = '/media/icons/IconClock.svg',
  IconClone = '/media/icons/IconClone.svg',
  IconClose = '/media/icons/IconClose.svg',
  IconCloseRound = '/media/icons/IconCloseRound.svg',
  IconCS = '/media/icons/IconCS.svg',
  IconDanger = '/media/icons/IconDanger.svg',
  IconDocumentDownload = '/media/icons/IconDocumentDownload.svg',
  IconDocumentCheck = '/media/icons/IconDocumentCheck.svg',
  IconDocumentCross = '/media/icons/IconDocumentCross.svg',
  IconDoubleChevronLeft = '/media/icons/IconDoubleChevronLeft.svg',
  IconDown = '/media/icons/IconDown.svg',
  IconDownload = '/media/icons/IconDownload.svg',
  IconDownload2 = '/media/icons/IconDownload2.svg',
  IconDelete = '/media/icons/IconDelete.svg',
  IconDrag = '/media/icons/IconDrag.svg',
  IconDuplicate = '/media/icons/IconDuplicate.svg',
  IconEdit = '/media/icons/IconEdit.svg',
  IconEmot = '/media/icons/IconEmot.svg',
  IconEyeOn = '/media/icons/IconEyeOn.svg',
  IconEyeOff = '/media/icons/IconEyeOff.svg',
  IconEnvelope = '/media/icons/IconEnvelope.svg',
  IconExclamation = '/media/icons/IconExclamation.svg',
  IconExternalLink = '/media/icons/IconExternalLink.svg',
  IconFilter = '/media/icons/IconFilter.svg',
  IconFile = '/media/icons/IconFile.svg',
  IconFileCSV = '/media/icons/IconFileCSV.svg',
  IconForbidden = '/media/icons/IconForbidden.svg',
  IconImagePlaceholder = '/media/icons/IconImagePlaceholder.svg',
  IconInfo = '/media/icons/IconInfo.svg',
  IconInfoOutline = '/media/icons/IconInfoOutline.svg',
  IconInfoOutline2 = '/media/icons/IconInfoCircleOutline.svg',
  IconJobTask = '/media/icons/IconJobTask.svg',
  IconKey = '/media/icons/IconKey.svg',
  IconKey2 = '/media/icons/IconKey2.svg',
  IconLaptop = '/media/icons/IconLaptop.svg',
  IconLoading = '/media/icons/IconLoading.svg',
  IconMoon = '/media/icons/IconMoon.svg',
  IconPaginationRight = '/media/icons/IconPaginationRight.svg',
  IconPaginationLeft = '/media/icons/IconPaginationLeft.svg',
  IconPaperPlane = '/media/icons/IconPaperPlane.svg',
  IconRepeat = '/media/icons/IconRepeat.svg',
  IconReassign = '/media/icons/IconReassign.svg',
  IconRefresh = '/media/icons/IconRefresh.svg',
  IconSearch = '/media/icons/IconSearch.svg',
  IconSun = '/media/icons/IconSun.svg',
  IconUser = '/media/icons/IconUser.svg',
  IconUser2 = '/media/icons/IconUser2.svg',
  IconUserFriends = '/media/icons/IconUserFriends.svg',
  IconUp = '/media/icons/IconUp.svg',
  IconUpDown = '/media/icons/IconUpDown.svg',
  IconUpload = '/media/icons/IconUpload.svg',
  IconSignOut = '/media/icons/IconSignOut.svg',
  IconView = '/media/icons/IconView.svg',
  IconWarning = '/media/icons/IconWarning.svg',
  IconWarning2 = '/media/icons/IconWarning2.svg',
  IconWarningCircle = '/media/icons/IconWarningCircle.svg',
  IconPoint = '/media/icons/IconPoint.svg',
  IconMapFolded = '/media/icons/IconMapFolded.svg',
  IconPdfPlaceholder = '/media/icons/IconPdfPlaceholder.svg',
  IconPointerMap = '/media/icons/IconPointerMap.svg',
}

export type GIconProps = keyof typeof GIconCollection

type Props = {
  icon: GIconProps
  className?: string
  onClick?: () => void
}

const GIcon: FC<Props> = ({icon, className, onClick}) => {
  return (
    <InlineSVG src={toAbsoluteUrl(GIconCollection[icon])} className={className} onClick={onClick} />
  )
}

export default GIcon
